import Hero from "../designSystem/Hero";
import SEO from "../designSystem/SEO";
import MortgageRepaymentCalculator from "../calculators/MortgageRepaymentCalculator";
import CalculatorImage from "../../assets/images/homepage_01.png";

const CalculatorIcon = () => (
  <span
    className="row-center bg-gray-3 p-m all-radius-l text-primary-2"
    aria-hidden="true"
  >
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="5" y="3" width="14" height="18" rx="1" />
      <path d="M8 6h8v4H8zM8 14h1M12 14h1M16 14h1M8 18h1M12 18h1M16 18h1" />
    </svg>
  </span>
);

const MortgageCalculatorsPage = () => {
  return (
    <div>
      <SEO
        title="Mortgage Calculators"
        description="Explore CAPC mortgage calculators for borrowing estimates, monthly repayments and property transaction tax."
        path="/mortgage-calculators"
      />

      <Hero
        title="Mortgage Calculators"
        // subtitle="TAG Mortgages"
        backgroundImage={CalculatorImage}
        showContactButton={false}
      />

      <section className="background-container bg-gray-3">
        <div className="content-container row-center grid2 gap-xxxxl row-center">
        
            <CalculatorIcon />
            <div className="column  gap-l">
              <h4 className="text-primary-1">Mortgage Repayment Calculator</h4>
              <div className="column gap-m">
                <div className="content text-gray-1">
                  Use our mortgage repayment calculator to estimate your monthly
                  mortgage payments in just a few moments. Simply enter your
                  loan amount, interest rate, mortgage term, and any other
                  relevant details to get an instant estimate of your
                  repayments.
                </div>
                <div className="content text-gray-1">
                  Whether you're buying your first home, moving property, or
                  remortgaging, this calculator can help you understand how
                  different loan amounts, interest rates, and repayment terms
                  could affect your monthly budget. The results are intended as
                  a guide and can help you compare scenarios before speaking
                  with us.
                </div>
              </div>
              <div className="body2 text-primary-1">
                Your home may be repossessed if you do not keep up repayments on
                your mortgage.
              </div>
            </div>
          </div>

    
      </section>

      <MortgageRepaymentCalculator />

      <section className="background-container bg-primary-1">
        <div className="content-container">
          <div className="column-center gap-l">
            <div className="body-2  text-white uppercase">
              - LET’S GET YOU MOVING
            </div>
            <h4 className="text-white text-center">
              Whether you're taking your first step onto the property ladder or
              expanding your investment portfolio, TAG Mortgages is here to
              help.
            </h4>
            <div className="content text-white text-center">
              Get in touch today and discover how simple arranging your mortgage
              can be.
            </div>
            <div className="body1 text-white">
              Your home may be repossessed if you do not keep up repayments on
              your mortgage.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MortgageCalculatorsPage;
